import Cookies from 'js-cookie';

if ($(location).attr("pathname") == "/planner") {
    require("devextreme/ui/scheduler");
    var Calendar = require("devextreme/ui/calendar")

    var DataSource = require("devextreme/data/data_source");
    var CustomStore = require("devextreme/data/custom_store");
    var ArrayStore = require("devextreme/data/array_store");
    var aspData = require("devextreme-aspnet-data");

    require("devextreme-intl");
    // Dictionaries for Dutch language
    const nlMessages = require("devextreme/localization/messages/nl.json");
    const localization = require("devextreme/localization");

    localization.loadMessages(nlMessages);
    //localization.locale(navigator.language || navigator.browserLanguage); Most messages are hardcoded ducth so don't mix en browser with dutch
    localization.locale("nl");

    var url = "/planner/api";
    var timezone = "Europe/Paris";
    var users = 0;
    var getemployees_url = "/planner/api/getemployees/get";
    var projects = [];
    var absencetypes = [];
    var jobfunctions = [];
    var eventtypes = [];
    var holidays = [];
    var employements = [];
    var addedCalenderWeek = false;

    function getHolidays(year) {
        var cacheKey = "holidays_" + year;
        var yesterday = new Date(new Date().setDate(new Date().getDate()-1));

        let holidayData = JSON.parse(localStorage.getItem(cacheKey));

        if (holidayData !== null && Date.parse(holidayData.retrieved_at) > yesterday) {
            holidays = holidayData.holidays;
        } else {
            $.ajax({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                },
                url: url + "/holidays/" + year,
                type: "GET",
                success(data) {
                    holidays = data;
                    localStorage.setItem(
                        cacheKey,
                        JSON.stringify({
                            holidays: holidays,
                            retrieved_at: new Date(),
                        })
                    );
                }
            });
        }
    }

    $(function() {
        $.ajax({
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
            },
            url: url + "/data",
            type: "GET",
            success(data) {
                projects = data.projects;
                absencetypes = data.absencetypes;
                jobfunctions = data.jobfunctions;
                eventtypes = data.eventtypes;
                users = data.nrOfEmployees;
                employements = data.userEmployements;
                initScheduler();
            }
        });
    });

    function initScheduler() {
        var viewCookie = Cookies.get('planning_view');
        var dateCookie = Cookies.get('planning_date');
        var initialView = viewCookie ? viewCookie : 'timelineWeek';
        var initialDate = dateCookie ? new Date(dateCookie) : new Date();

        var projectsStore = new DataSource({
            store: new ArrayStore({
                data: projects
            })
        });

        if (typeof url !== "undefined") {
            var schedulerStore = aspData.createStore({
                key: ["id", "type", "deleterecurrency","deletefuture"],
                loadUrl: url + "/get",
                insertUrl: url + "/post",
                updateUrl: url + "/put",
                deleteUrl: url + "/delete",
                onBeforeSend: function(method, ajaxOptions, e) {
                    ajaxOptions.xhrFields = { withCredentials: true };
                    ajaxOptions.headers = {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    };
                }
            });
        }

        if (typeof getemployees_url !== "undefined") {
            var employeesStore = new DataSource({
                store: new CustomStore({
                    load: function(loadOptions) {
                        var viewType, beginDate, endDate;
                        if (typeof loadOptions.filter !== "undefined") {
                            viewType = loadOptions.filter[0][2];
                            beginDate = loadOptions.filter[1][2];
                            endDate = loadOptions.filter[2][2];
                        } else {
                            // on first load use default current week Mon till Sun
                            viewType = initialView;
                            beginDate = getFirstDayOfWeek(initialDate);
                            endDate = getLastDayOfWeek(initialDate);
                        }
                        if (viewType && beginDate && endDate) {
                            return $.ajax({
                                headers: {
                                    "X-CSRF-TOKEN": $(
                                        'meta[name="csrf-token"]'
                                    ).attr("content")
                                },
                                url: getemployees_url,
                                type: "POST",
                                data: {
                                    viewtype: viewType,
                                    beginDate: beginDate,
                                    endDate: endDate
                                },
                                dataType: "JSON",
                                success: function(employees) {
                                    return employees;
                                }
                            });
                        }
                    }
                })
            });
        }

        var menuItemsEmpty = [
            { text: "Maak een Evenement aan", type: "event_item" },
            { text: "Maak een AfwezigheidsItem aan", type: "absence_item" },
            { text: "Maak een ProjectItem aan", type: "job_item" }
        ];

        window.subscribeToDropEvent = function() {
            $(".dx-scheduler-date-table-cell").unbind("dxdrop");
            $(".dx-scheduler-date-table-cell").on("dxdrop", function(e) {
                if (!canEdit()) {
                    return;
                }
                if ($(e.draggingElement).data("was-dragged")) {
                    var cellData = $(e.target).data("dxCellData");
                    $(e.draggingElement)
                        .css("top", 0)
                        .css("left", 0);
                    var start = cellData.startDate.toISOString();
                    var end = cellData.endDate.toISOString();
                    var ownerId = [cellData.groups.ownerId];
                    var ProjectId = [$(e.draggingElement).data("project-id")];
                    var AbsenceType = [
                        $(e.draggingElement).data("absence-type")
                    ];
                    var EventId = [$(e.draggingElement).data("event-id")];
                    var JobFunctionId = [
                        $(e.draggingElement).data("jobfunction-id")
                    ];
                    var pencilIn = false;
                    var type = [$(e.draggingElement).data("item-type")];
                    var description = "";

                    scheduler.addAppointment({
                        startDate: start,
                        endDate: end,
                        ownerId: ownerId,
                        type: type,
                        ProjectId: ProjectId,
                        AbsenceTypeId: AbsenceType,
                        EventId: EventId,
                        JobFunctionId: JobFunctionId,
                        pencilIn: pencilIn,
                        description: description
                    });
                }
                //$("#innerElement").css("visibility", 'hidden');
            });
        };

        if (typeof schedulerStore !== "undefined") {
            var dayOfWeekNames = [
                "Zon",
                "Maa",
                "Din",
                "Woe",
                "Don",
                "Vri",
                "Zat"
            ];

            var dateCellTemplate = function(cellData, index, container) {
                var holidayData = isNationalHoliday(cellData.date);
                var extraClass = "";
                if (typeof holidayData !== "undefined") {
                    extraClass = "holidayWeek";
                    cellData.text = cellData.text + ' ' + holidayData.name;
                }
                container.append(
                    $("<div />")
                        .addClass("name " + extraClass)
                        .text(dayOfWeekNames[cellData.date.getDay()]),
                    $("<div />")
                        .addClass("number " + extraClass)
                        .text(cellData.date.getDate())
                );
                if (typeof holidayData !== "undefined") {
                    container.append(
                        $("<div />")
                            .addClass("holidayWeekTitle " + extraClass)
                            .text(holidayData.name)
                    );
                }
            };
            var dateCellTemplateMonth = function(cellData, index, container) {
                var holidayData = isNationalHoliday(cellData.date);
                var extraClass = "";
                if (typeof holidayData !== "undefined") {
                    extraClass = "holidaymonth";
                    cellData.text = cellData.text + ' ' + holidayData.name;
                }
                container.append(
                    $("<div />")
                        .addClass("namemonth " + extraClass)
                        .text(dayOfWeekNames[cellData.date.getDay()]),
                    $("<div />")
                        .addClass("numbermonth " + extraClass)
                        .text(cellData.date.getDate())
                );
            };
            Date.prototype.getWeekNumber = function () {
                var d = new Date(+this);
                d.setHours(0, 0, 0);
                d.setDate(d.getDate() + 4 - (d.getDay() || 7));
                return Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
            };

            var schedulerIns;
            var scheduler = $("#scheduler")
                .dxScheduler({
                    dataSource: schedulerStore,
                    views: [
                        {
                            name: "Week",
                            type: "timelineWeek",
                            startDateHour: 0,
                            endDateHour: 24,
                            cellDuration: 1440,
                            // startDate: new Date(Date.now()),
                            maxAppointmentsPerCell: "unlimited",
                            dateCellTemplate: dateCellTemplate
                        },
                        {
                            name: "Maand",
                            type: "timelineMonth",
                            intervalCount: 1,
                            startDate: new Date(Date.now()),
                            maxAppointmentsPerCell: "unlimited",
                            dateCellTemplate: dateCellTemplateMonth
                        },
                        {
                            name: "2 Maanden",
                            type: "timelineMonth",
                            intervalCount: 2,
                            startDate: new Date(Date.now()),
                            maxAppointmentsPerCell: "unlimited",
                            dateCellTemplate: dateCellTemplateMonth
                        }
                    ],
                    //timeZone: timezone,
                    currentView: initialView,
                    currentDate: initialDate,
                    recurrenceEditMode: "series",
                    remoteFiltering: true,
                    firstDayOfWeek: 1,
                    showCurrentTimeIndicator: false,
                    groups: ["ownerId"],
                    resources: [
                        {
                            allowMultiple: false,
                            dataSource: employeesStore,
                            fieldExpr: "ownerId",
                            label: "Medewerker",
                            useColorAsDefault: true
                        },
                        {
                            allowMultiple: false,
                            dataSource: projectsStore,
                            fieldExpr: "ProjectId",
                            label: "Project",
                            useColorAsDefault: true
                        }
                    ],
                    editing: {
                        allowAdding: canEdit(),
                        allowDeleting: canEdit(),
                        allowDragging: canEdit(),
                        allowResizing: canEdit(),
                        allowUpdating: canEdit()
                    },
                    dataCellTemplate: function(cellData, index, container) {
                        var holiday =
                            typeof isNationalHoliday(cellData.startDate) !==
                            "undefined"
                                ? true
                                : false;
                        var weekendOrHoliday =
                            isWeekEnd(cellData.startDate) || holiday
                                ? "true"
                                : "false";
                        var wrapper = $("<div>")
                            .toggleClass("weekend-" + weekendOrHoliday)
                            //.toggleClass("weekend-" + holiday)
                            .appendTo(container)
                            .addClass("dx-template-wrapper");

                        wrapper.append(
                            $("<div>")
                                .text(cellData.text)
                                .addClass("day-cell")
                        );
                    },
                    resourceCellTemplate: function(data, index, element) {
                        var tooltip = '';
                        if (data.id !== 0) {
                            tooltip = 'data-html="true" data-toggle="tooltip" title="' +
                                'Telefoon zakelijk: ' + data.data.phonenumber_business + '<br>' +
                                'Telefoon privé/vast: ' + data.data.phonenumber + '<br>' +
                                'Email: ' + data.data.email +
                            '" ';
                        }

                        var employmentHtml = "";
                        var contentClass = "";
                        if (data.data.employment) {
                            var employmentIcon;
                            switch (data.data.employment) {
                                case "Zzp-er":
                                    employmentIcon = "user-tie";
                                    break;
                                case "MCN":
                                    employmentIcon = "wrench";
                                    contentClass = "dx-scheduler-group-header-content-employment";
                                    break;
                                case "Inleen":
                                    employmentIcon = "sign-in-alt";
                                    break;
                                case "Payroll/uitzend":
                                    employmentIcon = "coins";
                                    break;
                                default:
                                    employmentIcon = "user";
                                    break;
                            }
                            employmentHtml =
                                '<div class="group-header-icon tooltip-container"' +
                                    'data-toggle="tooltip"' +
                                    'title="' + data.data.employment + '"' +
                                '>' +
                                    '<i class="fas fa-' + employmentIcon + '"></i>' +
                                '</div>';
                        }

                        element.append(
                            '<div data-employee-id="' + data.id + '" ' +
                                'class="data ' + contentClass + '">' +
                                '<div class="group-header-title" ' + tooltip + '>' +
                                    data.text +
                                '</div>' +
                                employmentHtml +
                            '</div>'
                        );
                    },
                    height: users * 32 + 110,
                    appointmentTooltipTemplate: function(data, element) {
                        var markup = getTooltipTemplate(data);

                        //alter appointment date to 1 date
                        var date = markup.find(".dx-scheduler-appointment-tooltip-date").html()
                        markup.find(".dx-scheduler-appointment-tooltip-date").html(date.split("-")[0])

                        // Go to appointment info
                        markup.find(".edit-appointment").dxButton({
                            text: canEdit() ? "Wijzigen" : "Bekijken",
                            type: "default",
                            stylingMode: "outlined",
                            icon: canEdit() ? "edit" : "search",
                            onClick: function() {
                                scheduler.showAppointmentPopup(data, false);
                            }
                        });
                        markup
                            .find(".edit-appointment")
                            .after(
                                "<div class='copy-appointment pull-right'></div>"
                            );

                        var deleteWithWorkorderMessage = "Er is momenteel een werkbon voor deze week, voor dit project," +
                            " als er geen planningsitems meer zijn voor deze week dan wordt de " +
                            "werkbon automatisch verwijderd bij openen.";

                        if (canEdit()) {
                            markup.find(".copy-appointment").dxButton({
                                text: "Kopieren",
                                type: "default",
                                stylingMode: "outlined",
                                icon: "edit",
                                onClick: function() {
                                    if (data.recurrenceRuleCopy) {
                                        data.repeatOnOff = true;
                                        data.recurrenceRule = data.recurrenceRuleCopy;
                                    }
                                    scheduler.showAppointmentPopup(data, true);
                                }
                            });

                            // Delete appointment
                            markup.find(".delete-appointment").dxButton({
                                type: "default",
                                stylingMode: "outlined",
                                icon: "trash",
                                onClick: function () {
                                    //console.log(data);
                                    var r = true;
                                    if (data.type == 'job_item' && data.workorders > 0) {
                                        r = confirm(deleteWithWorkorderMessage);
                                    }
                                    if (r == true) {
                                        data.deleterecurrency = false;
                                        scheduler.deleteAppointment(data);
                                        scheduler.hideAppointmentTooltip();
                                    }
                                }
                            });

                            if (data.recurrenceRuleCopy) {
                                markup
                                    .find(".delete-appointment")
                                    .after(
                                        "<div class='delete-appointment-all pull-left'></div>"
                                    );

                                // Delete appointment (all)
                                markup.find(".delete-appointment-all").dxButton({
                                    type: "default",
                                    stylingMode: "outlined",
                                    icon: "trash",
                                    text: "serie",
                                    onClick: function () {
                                        //console.log(data);
                                        var r = true;
                                        if (data.type == 'job_item' && data.workorders > 0) {
                                            r = confirm(deleteWithWorkorderMessage);
                                        }
                                        if (r == true) {
                                            data.deleterecurrency = true;
                                            scheduler.deleteAppointment(data);
                                            scheduler.hideAppointmentTooltip();
                                        }
                                    }
                                });
                            }

                            if (markup.find(".delete-appointment-all").length > 0) {
                                markup
                                    .find(".delete-appointment-all")
                                    .after(
                                        "<div class='delete-appointment-future pull-left'></div>"
                                    );
                            } else {
                                markup
                                    .find(".delete-appointment")
                                    .after(
                                        "<div class='delete-appointment-future pull-left'></div>"
                                    );
                            }


                            // Delete appointment (all)
                            markup.find(".delete-appointment-future").dxButton({
                                type: "default",
                                stylingMode: "outlined",
                                icon: "trash",
                                text: "Toekomstig",
                                onClick: function () {
                                    //console.log(data);
                                    var r = true;
                                    if (data.type == 'job_item' && data.workorders > 0) {
                                        r = confirm("Er zit nog een werkbon aan dit project gekoppeld, weet u zeker dat u het project wilt verwijderen?");
                                    }
                                    if (r == true) {
                                        data.deletefuture = true;
                                        scheduler.deleteAppointment(data);
                                        scheduler.hideAppointmentTooltip();
                                    }
                                }
                            });
                        }

                        return markup;
                    },
                    appointmentTemplate: function(e) {
                        var jobfunction2;
                        if (typeof e.JobFunctionId !== "undefined") {
                            jobfunction2 = e.JobFunctionId;
                        } else {
                            jobfunction2 = "";
                        }

                        var font_color = e.font_color === 1 ? "dark" : "light";

                        var descriptionBadge = "";
                        if (e.description) {
                            descriptionBadge =
                                '<i class="fa fa-comment appointment-icon" aria-hidden="true" title="' + e.description + '"></i>';
                        }

                        var celebrationBagde = "";
                        if (e.type == "birthday_item") {
                            celebrationBagde =
                                '<i class="fa fa-birthday-cake appointment-icon" aria-hidden="true"></i>';
                        }

                        return $(
                            "<div class='planner-appointment'>" +
                                "<div class='project-color-" +
                                font_color +
                                "'>" +
                                celebrationBagde +
                                descriptionBadge +
                                e.text +
                                "<div class='badge badge-appointment'>" +
                                jobfunction2 +
                                "</div>" +
                                "</div>" +
                                "</div>"
                        );
                    },
                    onAppointmentRendered: function(e) {
                        var class_uncertain = "badge-appointment-uncertain";
                        var font_color =
                            e.appointmentData.font_color === 1
                                ? "dark"
                                : "light";
                        var span_repeat =
                            "<div class='appointment-recurrence-icon appointment-recurrence-icon-" +
                            font_color +
                            "'><i class='fas fa-redo-alt'></i></div>";
                        var span =
                            "<div class='appointment-uncertain-icon appointment-uncertain-icon-" +
                            font_color +
                            "'><i class='far fa-question-circle' ></i></div>";

                        if (
                            e.appointmentData.recurrenceRule &&
                            typeof e.appointmentData.pencilInFrom !=
                                "undefined" &&
                            e.appointmentData.pencilInFrom &&
                            e.appointmentData.pencilIn
                        ) {

                            var startDate = new Date(
                                e.targetedAppointmentData.startDate
                            ).setHours(0);
                            var pencilInFrom = new Date(
                                e.appointmentData.pencilInFrom
                            ).setHours(0);
                            if (startDate >= pencilInFrom) {
                                $(e.appointmentElement)
                                    .find(".badge.badge-appointment")
                                    .addClass(class_uncertain);
                                $(e.appointmentElement)
                                    .find(".badge.badge-appointment")
                                    .before(span);
                            }
                        } else if (e.appointmentData.pencilIn) {
                            $(e.appointmentElement)
                                .find(".badge.badge-appointment")
                                .addClass(class_uncertain);
                            $(e.appointmentElement)
                                .find(".badge.badge-appointment")
                                .before(span);
                        }

                        if (e.appointmentData.recurrenceRuleCopy) {
                            $(e.appointmentElement)
                                .find(".badge.badge-appointment")
                                .before(span_repeat);
                        }

                        if (e.appointmentData.type == "birthday_item" && canEdit()) {
                            e.appointmentElement.removeClass('dx-draggable');
                            e.appointmentElement.dxDraggable("instance").option("onDragStart", function(ev)  {
                                ev.element.removeClass("dx-draggable-dragging dx-state-focused dx-state-active");
                                ev.event.cancel = true;
                            });
                        }

                        $(e.appointmentElement).css(
                            "background-color",
                            e.appointmentData.color
                        );
                    },
                    onAppointmentDblClick: function(e) {
                        if (e.appointmentData.type == "birthday_item") {
                            e.cancel = true;
                        }
                    },
                    onAppointmentClick: function(e) {
                        if (e.appointmentData.type == "birthday_item") {
                            e.cancel = true;
                        }
                    },
                    onAppointmentFormOpening: function(e) {
                        var chosenDate = null;
                        if(e.component.option("resources[1].dataSource._items").length < e.component.option("resources[1].dataSource._store._array").length){
                            e.component.option("resources[1].dataSource._items", e.component.option("resources[1].dataSource._store._array"))  ;
                        }
                        var form = e.form;
                        var formItems = form.option("items");
                        var projectBtnExists = formItems.some(
                            e =>
                                e.buttonOptions &&
                                e.buttonOptions.text ===
                                    "open geselecteerde project"
                        );

                        //formItems.find(e => e.buttonOptions && e.buttonOptions.text === "open geselecteerde project").remove();
                        // e.appointmentData.recurrenceRuleCopy = "FREQ=WEEKLY;COUNT=2;BYDAY=MO,TU";
                        //e.appointmentData.recurrenceRule = "FREQ=WEEKLY;COUNT=2;BYDAY=MO,TU";
                        form.beginUpdate();

                        form.itemOption("endDate", {
                            visible: false,
                            editorOptions: {
                                type: "date"
                            },
                            validationRules: [
                                {
                                    type: "required",
                                    message: "Selecteren einddatum verplicht"
                                }
                            ]
                        });

                        if(e.appointmentData.startDate){
                            chosenDate = new Date(e.appointmentData.startDate);
                        }

                        form.itemOption("startDate", {
                            editorOptions: {
                                type: "date",
                                onValueChanged: function (args) {

                                    var startDate = args.value;
                                    var chosenDate = new Date(startDate);
                                    var endDate = new Date(startDate);
                                    var date =  endDate.getDate() + '-' + (endDate.getMonth() + 1) + '-' +  endDate.getFullYear();
                                    //e.endDate = endDate.toISOString();
                                    $("#scheduler").dxScheduler("instance").option("endDate", date);
                                     form.$element().find(".dx-recurrence-datebox-until-date input").val(date);
                                     form.$element().find(".dx-recurrence-datebox-until-date input").trigger('change');
                                    //console.log($("#scheduler").dxScheduler("instance").option("endDate"));

                                }
                            },
                            validationRules: [
                                {
                                    type: "required",
                                    message: "Selecteren startdatum verplicht"
                                }
                            ]
                        });
                        form.itemOption("description", {
                            //visible:false
                        });
                        form.itemOption("recurrenceRule", {
                            editorOptions: {

                                onValueChanged: function (args) {

                                    if(chosenDate != null && (args.previousValue && args.previousValue.indexOf('UNTIL=') == -1)){
                                        var endDate = new Date(chosenDate);
                                        var date =  endDate.getDate() + '-' + (endDate.getMonth() + 1) + '-' +  endDate.getFullYear();
                                        //$("#scheduler").dxScheduler("instance").option("endDate", date);
                                        form.$element().find(".dx-recurrence-datebox-until-date input").val(date);
                                        form.$element().find(".dx-recurrence-datebox-until-date input").trigger('change');

                                    }

                                }
                            }
                        });
                        form.itemOption("allDay", {
                            visible: false
                        });

                        form.itemOption("ownerId", {
                            // disabled: true,
                            validationRules: [
                                {
                                    type: "required",
                                    message: "Selecteren medewerker verplicht"
                                }
                            ]
                        });

                        form.itemOption("ProjectId", {
                            validationRules: [
                                {
                                    type: "required",
                                    message: "Selecteren project verplicht"
                                }
                            ]
                        });

                        var absence = {
                            dataField: "AbsenceTypeId",
                            editorType: "dxRadioGroup",
                            editorOptions: {
                                items: absencetypes,
                                displayExpr: "name",
                                valueExpr: "external_code"
                            },
                            validationRules: [
                                {
                                    type: "required",
                                    message:
                                        "Selecteren type afwezigheid verplicht"
                                }
                            ],
                            label: {
                                text: "Afwezigheid"
                            }
                        };

                        var functions = {
                            dataField: "JobFunctionId",
                            editorType: "dxRadioGroup",
                            editorOptions: {
                                items: jobfunctions,
                                displayExpr: "function_name",
                                valueExpr: "code"
                            },
                            validationRules: [
                                {
                                    type: "required",
                                    message:
                                        "Selecteren projectfunctie verplicht"
                                }
                            ],
                            label: {
                                text: "Functie"
                            }
                        };

                        var pencilInFrom = {
                            dataField: "pencilInFrom",
                            editorType: "dxDateBox",
                            editorOptions: {
                                disabled: false,
                                value: e.appointmentData.pencilInFrom
                                    ? e.appointmentData.pencilInFrom
                                    : getToday()
                            },
                            label: {
                                text: "Onzeker Vanaf"
                            }
                        };

                        var pencilIn = {
                            dataField: "pencilIn",
                            editorType: "dxCheckBox",
                            editorOptions: {
                                value: e.appointmentData.pencilIn ? e.appointmentData.pencilIn : false,
                                disabled: false
                            },
                            label: {
                                text: "Onzeker"
                            }
                        };

                        var selectGroupForEvent = {
                            dataField: "groupId",
                            editorType: "dxSelectBox",
                            editorOptions: {
                                items: employements,
                                value: e.appointmentData.groupId > 0 ? e.appointmentData.groupId : employements[0].id,
                                valueExpr: "id",
                                displayExpr: "title",
                                disabled: false
                            },
                            label: {
                                text: "Groep"
                            }
                        };

                        var textAreaTemplate = '<div class="dx-item dx-box-item" style="display: flex; min-height: auto; flex-grow: 1; flex-shrink: 1;">'+
                                                    '<div class="dx-item-content dx-box-item-content" style="width: auto; height: auto; display: flex; flex-basis: 0px; flex-grow: 1; flex-direction: column;">'+
                                                        '<div class="dx-first-col dx-last-col dx-field-item dx-col-0 dx-field-item-optional dx-field-item-label-align dx-flex-layout dx-label-h-align">'+
                                                            '<label class="dx-field-item-label dx-field-item-label-location-left" for="dx_dx-1a9e6ffa-d6d4-f53e-98c2-8116eb025115_description">'+
                                                              '<span class="dx-field-item-label-content" style="width: 102px;">'+
                                                                '<span class="dx-field-item-label-text">%fieldname</span>'+
                                                              '</span>'+
                                                            '</label>'+
                                                            '<div class="dx-field-item-content dx-field-item-content-location-right">'+
                                                                '<div class="dx-textarea dx-textbox dx-texteditor dx-editor-outlined dx-widget dx-visibility-change-handler dx-texteditor-empty">'+
                                                                    '<div class="dx-texteditor-container">'+
                                                                        "<div>%text</div>"+
                                                                        "<div>%contactpersons</div>"+
                                                                    '</div>'+
                                                                '</div>'+
                                                            '</div>'+
                                                        '</div>'+
                                                    '</div>'+
                                                '</div>';

                        function createCustomTemplateProjectInfo(textAreaTemplate) {
                            var projectInfo = "<table>";

                            if (e.appointmentData.project.project_nr_mcn != null) {
                                projectInfo = projectInfo +
                                                "<tr>"+
                                                    "<td width='150px'>Projectnummer:</td><td>"+e.appointmentData.project.project_nr_mcn+"</td>"+
                                                "</tr>";
                            }
                            if (e.appointmentData.project.name != null) {
                                projectInfo = projectInfo +
                                                "<tr>"+
                                                    "<td width='150px'>Projectnaam:</td><td>"+e.appointmentData.project.name+"</td>"+
                                                "</tr>";
                            }
                            if (e.appointmentData.project.address != null) {
                                projectInfo = projectInfo +
                                                "<tr>"+
                                                    "<td width='150px'>Adres:</td><td>"+e.appointmentData.project.address+"</td>"+
                                                "</tr>";
                            }
                            if (e.appointmentData.project.postal_code != null || e.appointmentData.project.city != null) {
                                projectInfo = projectInfo +
                                                "<tr><td width='150px'></td><td>";
                                    if (e.appointmentData.project.postal_code != null) {
                                        projectInfo = projectInfo + e.appointmentData.project.postal_code;
                                    }
                                    projectInfo = projectInfo + " ";
                                    if (e.appointmentData.project.city != null) {
                                        projectInfo = projectInfo + e.appointmentData.project.city;
                                    }

                                projectInfo = projectInfo + "</td></tr>";
                            }
                            projectInfo = projectInfo + "</table>";

                            var contactpersonsInfo = "<table>" +
                                                        "<tr>"+
                                                            "<td collspan='2'>Contactpersonen:</td>"+
                                                        "</tr>";


                            if (
                                typeof e.appointmentData.contactpersons !=
                                    "undefined" &&
                                e.appointmentData.contactpersons.length > 0
                            ) {
                                e.appointmentData.contactpersons.forEach(function(
                                    item
                                ) {

                                    if (item.phonenumber != null) {
                                        contactpersonsInfo = contactpersonsInfo +
                                        "<tr>"+
                                            "<td width='150px'>"+item.name+"</td><td>"+item.phonenumber+"</td>"+
                                        "</tr>";
                                    } else {
                                        contactpersonsInfo = contactpersonsInfo +
                                        "<tr>"+
                                            "<td width='150px'>"+item.name+"</td><td>&nbsp;</td>"+
                                        "</tr>";
                                    }

                                    if (item.phonenumber2 != null) {
                                    contactpersonsInfo = contactpersonsInfo +
                                        "<tr>"+
                                            "<td width='150px'>Telefoon 2</td><td>"+item.phonenumber2+"</td>"+
                                        "</tr>";
                                    }

                                    if (item.phonenumber3 != null) {
                                    contactpersonsInfo = contactpersonsInfo +
                                        "<tr>"+
                                            "<td width='150px'>Telefoon 3</td><td>"+item.phonenumber3+"</td>"+
                                        "</tr>";
                                    }
                                });
                                contactpersonsInfo.concat("</table>");
                            }
                            var projectInfoTemplate = textAreaTemplate.replace("%text",projectInfo)
                            projectInfoTemplate = projectInfoTemplate.replace("%contactpersons",contactpersonsInfo)
                            projectInfoTemplate = projectInfoTemplate.replace("%fieldname","Projectinfo")
                            form.$element().find(".dx-selectbox").eq(1).closest(".dx-item.dx-box-item").after(projectInfoTemplate);
                        }

                        function setJobItemState() {
                            form.itemOption("text", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("AbsenceTypeId", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("ProjectId", {
                                visible: true,
                                disabled: false
                            });
                            form.itemOption("JobFunctionId", {
                                visible: true,
                                disabled: false
                            });
                            form.itemOption("pencilIn", {
                                visible: true,
                                disabled: false
                            });
                            form.itemOption("pencilInFrom", {
                                visible: true,
                                disabled: false
                            });

                            form.itemOption("groupId", {
                                visible: false,
                                disabled: true
                            });

                            if (
                                typeof e.appointmentData.recurrenceRule !=
                                    "undefined" &&
                                e.appointmentData.recurrenceRule
                            ) {
                                showPencilInFrom();
                            } else {
                                hidePencilInFrom();
                            }


                        }

                        function setAbsenceItemState() {
                            form.itemOption("text", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("AbsenceTypeId", {
                                visible: true,
                                disabled: false
                            });
                            form.itemOption("ProjectId", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("JobFunctionId", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("pencilIn", {
                                visible: true,
                                disabled: false
                            });
                            form.itemOption("pencilInFrom", {
                                visible: false,
                                disabled: true
                            });

                            form.itemOption("groupId", {
                                visible: false,
                                disabled: true
                            });
                        }

                        function setEventItemState() {
                            form.itemOption("text", {
                                visible: true,
                                disabled: false
                            });
                            form.itemOption("AbsenceTypeId", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("ProjectId", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("JobFunctionId", {
                                visible: false,
                                disabled: true
                            });
                            form.itemOption("pencilIn", {
                                visible: true,
                                disabled: false
                            });
                            form.itemOption("pencilInFrom", {
                                visible: false,
                                disabled: true
                            });

                            form.itemOption("groupId", {
                                visible: true,
                                disabled: false
                            });
                        }

                        function resetRecurrenceRule() {

                            var editor = form.getEditor("recurrenceRule");
                            var date;
                            date = new Date(e.appointmentData.endDate).toISOString().replace(/:/g, "").replace(/-/g,"");
                            //editor.option(
                            //    "value",
                            //    "FREQ=WEEKLY;COUNT=1;INTERVAL=1;UNTIL="+date
                           // );
                        }

                        function checkTypeAndShowPencilInFrom(data) {
                            types = eventtypes.map(a => a.id);
                            switch (data.type) {
                                case types[0]:
                                    if (
                                        typeof data.recurrenceRule !==
                                            "undefined" &&
                                        data.recurrenceRule
                                    ) {
                                        showPencilInFrom();
                                    } else {
                                        hidePencilInFrom();
                                    }
                                    break;
                                case types[1]:
                                    hidePencilInFrom();
                                    break;
                                case types[2]:
                                    hidePencilInFrom();
                                    break;
                            }
                        }

                        function checkTypeAndShowPencilInFromNew(type) {
                            var value = $("input[name*='repeatOnOff']").prop(
                                "value"
                            );
                            types = eventtypes.map(a => a.id);
                            switch (type) {
                                case types[0]:
                                    if (typeof value !== "undefined" && value) {
                                        showPencilInFrom();
                                    } else {
                                        hidePencilInFrom();
                                    }
                                    break;
                                case types[1]:
                                    hidePencilInFrom();
                                    break;
                                case types[2]:
                                    hidePencilInFrom();
                                    break;
                            }
                        }

                        function showPencilInFrom() {
                            $("input[name*='pencilInFrom']").prop(
                                "disabled",
                                false
                            );
                            $("input[name*='pencilInFrom']")
                                .parents()
                                .eq(5)
                                .show();
                        }

                        function hidePencilInFrom() {
                            $("input[name*='pencilInFrom']").prop(
                                "disabled",
                                true
                            );
                            $("input[name*='pencilInFrom']")
                                .parents()
                                .eq(5)
                                .hide();
                        }

                        function checkRepeatAndShowOrHide() {
                            var value = $("input[name*='repeatOnOff']").prop(
                                "value"
                            );
                            if (value === "true") {
                                $(".dx-scheduler-recurrence-rule-item").show();
                            } else {
                                $(".dx-scheduler-recurrence-rule-item").hide();
                            }
                        }

                        function toggleClassesRepeatOn() {
                            form.$element()
                                .find(".dx-scheduler-recurrence-rule-item")
                                .addClass(
                                    "dx-scheduler-recurrence-rule-item-opened"
                                );
                            form.$element()
                                .find(".dx-recurrence-editor")
                                .removeClass("dx-state-invisible");
                            form.$element()
                                .find(".dx-recurrence-switch-repeat-end")
                                .removeClass("dx-state-invisible");
                            form.$element()
                                .find(".dx-recurrence-editor-container")
                                .show();


                            //form.$element()
                            //.find(".dx-recurrence-datebox-until-date input").val($( "input[name='startDate']" ).val());
                        }

                        function toggleClassesRepeatOff() {
                            form.$element()
                                .find(".dx-scheduler-recurrence-rule-item")
                                .removeClass(
                                    "dx-scheduler-recurrence-rule-item-opened"
                                );
                            form.$element()
                                .find(".dx-recurrence-editor")
                                .addClass("dx-state-invisible");
                            form.$element()
                                .find(".dx-recurrence-switch-repeat-end")
                                .addClass("dx-state-invisible");
                            form.$element()
                                .find(".dx-recurrence-editor-container")
                                .hide();
                        }

                        function setRecurrencyEnd() {
                            var editor = form.getEditor("recurrenceRule");
                            editor._switchEndEditor.option("visible", false);
                            editor._switchEndEditor.option("value", true);
                            form.$element()
                                .find(".dx-recurrence-switch-repeat-end")
                                .hide();

                        }

                        function unsetRecurrencyEnd() {
                            var editor = form.getEditor("recurrenceRule");
                            editor._switchEndEditor.option("value", false);
                        }

                        var types = eventtypes.map(a => a.id);
                        var displaychoice = {
                            dataField: "type",
                            editorType: "dxRadioGroup",
                            editorOptions: {
                                layout: "horizontal",
                                items: eventtypes,
                                displayExpr: "name",
                                valueExpr: "id",
                                onValueChanged: function(e) {
                                    form.beginUpdate();
                                    types = eventtypes.map(a => a.id);
                                    switch (e.value) {
                                        //job_item
                                        case types[0]:
                                            setJobItemState();
                                            break;
                                        case types[1]:
                                            setAbsenceItemState();
                                            break;
                                        case types[2]:
                                            setEventItemState();
                                            break;
                                    }
                                    form.endUpdate();
                                    checkTypeAndShowPencilInFromNew(e.value);
                                    checkRepeatAndShowOrHide();
                                }
                            },
                            label: {
                                text: "Planningstype"
                            }
                        };

                        if (!formItems.find(i => i.dataField === "type")) {
                            formItems.push(displaychoice);
                        }

                        if (
                            !formItems.find(
                                i => i.dataField === "AbsenceTypeId"
                            )
                        ) {
                            formItems.push(absence);
                        }

                        formItems.forEach(function(item, key) {
                            if (item.dataField === "ProjectId") {
                                formItems.push(item);
                                formItems.splice(key, 1);
                            }
                        });

                        if (
                            !formItems.find(
                                i => i.dataField === "JobFunctionId"
                            )
                        ) {
                            formItems.push(functions);
                        }

                        if (!formItems.find(i => i.dataField === "groupId")) {
                            formItems.push(selectGroupForEvent);
                        } else {
                            formItems.forEach(function(item, key) {
                                if (item.dataField === "groupId") {
                                    formItems.splice(key, 1);
                                }
                            });

                            formItems.push(selectGroupForEvent);
                        }

                        formItems.forEach(function(item, key) {
                            if (item.dataField === "text") {
                                formItems.push(item);
                                formItems.splice(key, 1);
                            }
                        });

                        formItems.forEach(function(item, key) {
                            if (item.dataField === "description") {
                                formItems.push(item);
                                formItems.splice(key, 1);
                            }
                        });

                        if (!formItems.find(i => i.dataField === "pencilIn")) {
                            formItems.push(pencilIn);
                        } else {
                            formItems.forEach(function(item, key) {
                                if (item.dataField === "pencilIn") {
                                    formItems.splice(key, 1);
                                }
                            });

                            formItems.push(pencilIn);
                        }

                        if (
                            !formItems.find(i => i.dataField === "pencilInFrom")
                        ) {
                            formItems.push(pencilInFrom);
                        } else {
                            formItems.forEach(function(item, key) {
                                if (item.dataField === "pencilInFrom") {
                                    formItems.splice(key, 1);
                                }
                            });

                            formItems.push(pencilInFrom);
                        }

                        var onValueChangedBase = form.itemOption("repeatOnOff")
                            .editorOptions.onValueChanged;
                        form.itemOption("repeatOnOff", {
                            editorOptions: {
                                onValueChanged: function(e) {
                                    checkRepeatAndShowOrHide();
                                    if (e.value == true) {
                                        showPencilInFrom();
                                        setRecurrencyEnd();
                                        resetRecurrenceRule();
                                        toggleClassesRepeatOn();
                                    } else {
                                        hidePencilInFrom();
                                        unsetRecurrencyEnd();
                                        toggleClassesRepeatOff();
                                    }
                                }
                            }
                        });

                        var selectedProject = $(
                            "input[name*='ProjectId']"
                        ).prop("value");
                        var ProjectLink = {
                            itemType: "button",
                            buttonOptions: {
                                text: "open geselecteerde project",
                                type: "info",
                                visible: selectedProject ? true : false,
                                onClick: function() {
                                    selectedProject = $(
                                        "input[name*='ProjectId']"
                                    ).prop("value");
                                    if (selectedProject > 0) {
                                        document.location =
                                            "/project/edit/" + selectedProject + "?planning=1";
                                    }
                                }
                            }
                        };

                        var btnIndex = formItems.findIndex(
                            item =>
                                item.buttonOptions &&
                                item.buttonOptions.text ==
                                    "open geselecteerde project"
                        );
                        if (btnIndex > -1) {
                            formItems.push(formItems.splice(btnIndex, 1)[0]);
                        }

                        if (canEdit()) {
                            if (!projectBtnExists && selectedProject) {
                                formItems.push(ProjectLink);
                            } else if (!selectedProject && projectBtnExists) {
                                formItems = formItems.slice(0, -1);
                            }
                        }

                        form.option({
                            items: formItems
                        });

                        if (
                            e.appointmentData != null &&
                            typeof e.appointmentData.type !== "undefined"
                        ) {
                            form.itemOption("type", {
                                visible: false,
                                disabled: false
                            });
                            switch (e.appointmentData.type) {
                                case types[0]:
                                    setJobItemState();
                                    break;
                                case types[1]:
                                    setAbsenceItemState();
                                    break;
                                case types[2]:
                                    setEventItemState();
                                    break;
                                default:
                            }
                            form.endUpdate();
                            if (e.appointmentData.type == types[0]) {
                                createCustomTemplateProjectInfo(textAreaTemplate);
                            }
                            checkTypeAndShowPencilInFrom(e.appointmentData);
                        } else {
                            form.itemOption("type", {
                                visible: true,
                                disabled: false
                            });
                            resetRecurrenceRule();
                            setJobItemState();
                            form.endUpdate();
                            form.getEditor("type").option("value", types[0]);
                            hidePencilInFrom();
                        }

                        form.$element()
                            .find(".dx-recurrence-switch-repeat-end")
                            .hide();

                        // if (typeof e.appointmentData.repeatOnOff === "undefined") {
                        //     $(".dx-scheduler-recurrence-switch-item").show();
                        // } else if (e.appointmentData.repeatOnOff == true){
                        //     $(".dx-scheduler-recurrence-switch-item").hide();
                        //     setRecurrencyEnd();
                        // } else {
                        //     $(".dx-scheduler-recurrence-switch-item").hide();
                        // }
                        $("input[role*='spinbutton']")
                            .parent(".dx-texteditor-container")
                            .css("width", "80px");
                        checkRepeatAndShowOrHide();

                    },
                    onOptionChanged: function(e) {

                        if (
                            e.fullName == "dateSerializationFormat" ||
                            e.fullName == "currentView" ||
                            e.fullName == "currentDate"
                        ) {
                            setTimeout(function() {
                                if (e.value == "Week") {
                                    window.addSortable();
                                }
                            }, 0);

                            switch(e.fullName) {
                              case "dateSerializationFormat":
                                // var curr = new Date;
                                // var begin = new Date(curr.setDate(curr.getDate() - curr.getDay()+1));
                                // var end = new Date(curr.setDate(curr.getDate() - curr.getDay()+7));
                                // setEmployeesStore(e,begin,end,false);
                                break;
                              case "currentView":
                                Cookies.set('planning_view', e.value);

                                var curr = new Date;
                                switch(e.value) {
                                    case "Week":
                                        var curr = new Date(e.component._workSpace.option("currentDate"));
                                        var begin = new Date(curr.setDate(curr.getDate() - curr.getDay()+1));
                                        var end = new Date(curr.setDate(curr.getDate() - curr.getDay()+7));
                                        break;
                                    case "Maand":
                                        var curr = new Date (e.component._workSpace.option("currentDate"));
                                        var begin = new Date(curr.getFullYear(), curr.getMonth(), 1);
                                        var end = new Date(curr.getFullYear(), curr.getMonth()+1, 0);
                                    break;
                                    case "2 Maanden":
                                        var curr = new Date (e.component._workSpace.option("currentDate"));
                                        var begin = new Date(curr.getFullYear(), curr.getMonth(), 1);
                                        var end = new Date(curr.getFullYear(), curr.getMonth()+2, 0);
                                    break;
                                }
                                setEmployeesStore(e,begin,end,e.value);
                                break;
                              case "currentDate":
                                Cookies.set('planning_date', e.value);

                                switch(e.component._currentView.name) {
                                    case "Week":
                                        var curr = new Date(e.value);
                                        var begin = new Date(curr.setDate(curr.getDate() - curr.getDay()+1));
                                        var end = new Date(curr.setDate(curr.getDate() - curr.getDay()+7));
                                        break;
                                    case "Maand":
                                        var curr = new Date(e.value);
                                        var begin = new Date(curr.getFullYear(), curr.getMonth(), 1);
                                        var end = new Date(curr.getFullYear(), curr.getMonth()+1, 0);
                                    break;
                                    case "2 Maanden":
                                        var curr = new Date(e.value);
                                        var begin = new Date(curr.getFullYear(), curr.getMonth(), 1);
                                        var end = new Date(curr.getFullYear(), curr.getMonth()+2, 0);
                                    break;
                                }
                                setEmployeesStore(e,begin,end,e.component._currentView.name);
                                break;
                            }

                            function setEmployeesStore(e,begin,end,type) {
                                employeesStore.filter([
                                    ["viewtype", "=", type],
                                    ["from", ">=", begin],
                                    ["to", "<=", end]
                                ]);
                                e.component.option(
                                    "resources[0].dataSource",
                                    employeesStore
                                );
                            }
                        }
                    },
                    onInitialized: function(e) {
                        schedulerIns = e.component;
                    },
                    customizeDateNavigatorText: function(e) {
                        var formatOptions = {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                        };
                        var formattedStartDate = e.startDate.toLocaleString(
                            "en",
                            formatOptions
                        );
                        var formattedEndDate = e.endDate.toLocaleString(
                            "en",
                            formatOptions
                        );
                         //dirty place to get fholiday data
                         var dStart = new Date(e.startDate);
                         //also dirty
                         //fake somewhere in next month, sometimes 1 days isn't enough
                         dStart.setDate(dStart.getDate() + 3);
                         var dEnd = new Date(dStart.valueOf());
                         dEnd.setMonth(dEnd.getMonth() + 1);
                         getHolidays(dStart.getFullYear());
                         var view = schedulerIns.option("currentView");
                         if (view === "timelineWeek" || view === "Week") {
                             var result = getWeekNumber(new Date(e.startDate));
                             return result;
                         }
                         if (view === "Maand")
                             return dStart.toLocaleString("nl-NL", {
                                 month: "long",
                                 year: "numeric"
                             });
                         if (view === "2 Maanden")
                             return (
                                 dStart.toLocaleString("nl-NL", {
                                     month: "short",
                                     year: "numeric"
                                 }) +
                                 " - " +
                                 dEnd.toLocaleString("nl-NL", {
                                     month: "short",
                                     year: "numeric"
                                 })
                             );
                         return formattedStartDate + " - " + formattedEndDate;
                    },
                    onAppointmentUpdating: function(e) {
                        //take default methods first
                        e.newData.jobOverlapMethod = parseInt(
                            $("input[name=resolveJob]:checked").val()
                        );
                        e.newData.AbsenceOverlapMethod = parseInt(
                            $("input[name=resolveAbsence]:checked").val()
                        );
                        if (
                            typeof e.newData.repeatOnOff ==
                                "undefined" ||
                            e.newData.repeatOnOff == false
                        ) {
                            var endDate = new Date(e.newData.startDate);
                            endDate.setDate(endDate.getDate() + 1);
                            endDate.setHours(0, 0, 0);
                            e.newData.endDate = endDate.toISOString();
                        }
                        e.cancel = $.when(preCheckAppointment(e)).then(
                            function(status) {
                                e.newData.jobOverlapMethod = parseInt(
                                    $("input[name=resolveJob]:checked").val()
                                );
                                e.newData.AbsenceOverlapMethod = parseInt(
                                    $(
                                        "input[name=resolveAbsence]:checked"
                                    ).val()
                                );
                                return false;
                            },
                            function(status) {
                                return true;
                            }
                        );
                    },
                    onAppointmentAdding: function(e) {
                        //take default methods first
                        e.appointmentData.jobOverlapMethod = parseInt(
                            $("input[name=resolveJob]:checked").val()
                        );
                        e.appointmentData.AbsenceOverlapMethod = parseInt(
                            $("input[name=resolveAbsence]:checked").val()
                        );
                        //var startDate = new Date(e.appointmentData.startDate);
                       // e.appointmentData.startDate = startDate.toISOString();
                        if (
                            typeof e.appointmentData.repeatOnOff ==
                                "undefined" ||
                            e.appointmentData.repeatOnOff == false
                        ) {
                            var endDate = new Date(e.appointmentData.startDate);
                            endDate.setDate(endDate.getDate() + 1);
                            endDate.setHours(0, 0, 0);
                            e.appointmentData.endDate = endDate.toISOString();
                        }
                        e.cancel = $.when(preCheckAppointment(e)).then(
                            function(status) {
                                e.appointmentData.jobOverlapMethod = parseInt(
                                    $("input[name=resolveJob]:checked").val()
                                );
                                e.appointmentData.AbsenceOverlapMethod = parseInt(
                                    $(
                                        "input[name=resolveAbsence]:checked"
                                    ).val()
                                );
                                return false;
                            },
                            function(status) {
                                return true;
                            }
                        );
                    },
                    onContentReady: function(e) {
                        e.component.option("editing.allowResizing", false);
                        if (e.component._currentView.type == "timelineMonth") {
                            $("#projectsToggler").addClass("disabled");
                            $("#sidebarProjects").removeClass("active");
                        } else {
                            $("#projectsToggler").removeClass("disabled");
                            window.subscribeToDropEvent();
                            if (canEdit()) {
                                window.addSortable();
                            }
                        }

                        e.component.option(
                            "height",
                            e.component.option("resources[0].dataSource._items")
                                .length *
                                32 +
                                110
                        );


                        var element = document.querySelectorAll(".dx-scheduler-navigator");

                        element[0].addEventListener("click",  event => {
                            setTimeout(()=>{
                                var cal = document.querySelectorAll(".dx-scheduler-navigator-calendar");
                                var instance = Calendar.getInstance(cal);
                                instance.option("showTodayButton", true);
                                instance.option("cellTemplate",  function (itemData, itemIndex, itemElement) {

                                    if (itemData.view != "month" || itemIndex != 6)
                                        return "cell"
                                    var weekNumber = itemData.date.getWeekNumber();
                                    var tr = itemElement.parent();
                                    var td = $('<td>' );
                                    $("<div>").text(itemData.text).appendTo(itemElement);
                                    $("<div>").text(weekNumber).addClass("weekNumberStyle").on("click", function (e) {
                                        instance.option("value", itemData.date);
                                        e.stopPropagation();
                                    }).appendTo(td);
                                    td.appendTo(tr);


                                });

                            });
                        }, 100);

                        $(".tooltip").tooltip("hide");
                    }
                })
                .dxScheduler("instance");

            window.subscribeToDropEvent();

            function preCheckAppointment(e) {
                $("#warningAppointmentModalDialog").addClass("d-none");
                // $("#warningAppointmentModal").modal({
                //     backdrop: "static",
                //     keyboard: false
                // });
                var data;
                if (e.appointmentData){
                    data = e.appointmentData;
                }
                if (e.newData){
                    data = e.newData;
                }
                var dfd = jQuery.Deferred();
                $("#warningAppointmentModal").on(
                    "click",
                    "#processAppointment",
                    function() {
                        dfd.resolve(e);
                    }
                );
                $("#cancelAppointment").click(function() {
                    dfd.reject();
                });
                /* Check if planner is overlapping abcense and/or jobs */
                $.ajax({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    },
                    url: url + "/checkappointment",
                    type: "post",
                    data: data,
                    success(result) {
                        $("#jobAppointment").addClass("d-none");
                        $("#absenceAppointment").addClass("d-none");
                        var overlapping = false;
                        if (result === "ABSENCE") {
                            overlapping = true;
                            $("#absenceAppointment").removeClass("d-none");
                        }
                        if (result === "JOB") {
                            overlapping = true;
                            $("#jobAppointment").removeClass("d-none");
                        }
                        if (result === "JOBABSENCE") {
                            overlapping = true;
                            $("#jobAppointment").removeClass("d-none");
                            $("#absenceAppointment").removeClass("d-none");
                        }
                        if (overlapping) {
                            $("#warningAppointmentModalDialog").removeClass(
                                "d-none"
                            );
                            $("#warningAppointmentModal").modal("show");
                        } else {
                            dfd.resolve(e);
                        }
                    }
                });
                dfd.always(function() {
                    $("#warningAppointmentModal").modal("hide");
                });
                return dfd.promise();
            }

            function test() {}

            $(".draggable-element")
                .draggable({
                    revert: "false",
                    cursor: "move",
                    helper: "clone",
                    cursorAt: { left: "8", top: "2" },
                    appendTo: "#scheduler",
                    containment: "#scheduler",
                    start: function(e, ui) {
                        var contCoord = $(this).draggable("instance")
                            .containment;
                        //make it possible to drag back to projects
                        contCoord[2] =
                            contCoord[2] + $("#sidebarProjects").width() + 60;
                        contCoord[0] = 0;
                    }
                })
                .on({
                    dxdragstart: test
                });
        }

        function isWeekEnd(date) {
            var day = date.getDay();
            return day === 0 || day === 6;
        }

        function isNationalHoliday(date) {
            var result = holidays.find(obj => {
                var x = new Date(date);
                x.setHours(0, 0, 0, 0);
                var y = new Date(obj.date);
                y.setHours(0, 0, 0, 0);
                return x.valueOf() === y.valueOf();
            });

            return result;
        }

        function getTooltipTemplate(data) {
            var formatter = new Intl.DateTimeFormat("nl", {
                day: "numeric",
                month: "long",
                year: "numeric"
            });
            var startDate = formatter.format(new Date(data.startDate));
            // startDate = startDate.getDate() + "-" + startDate.getMonth() + "-" + startDate.getFullYear();
            var mcnProjectNr = (typeof data.project != "undefined" && data.project !== null && data.project.project_nr_mcn !== null ) ? data.project.project_nr_mcn : '';
            var endDate = formatter.format(new Date(data.endDate));
            var address = (typeof data.project != "undefined" && data.project !== null && data.project.address !== null ) ? data.project.address : '';
            var postcode = (typeof data.project != "undefined" && data.project !== null && data.project.postal_code !== null ) ? data.project.postal_code : '';
            var city =  (typeof data.project != "undefined" && data.project !== null && data.project.city !== null ) ? data.project.city : '';
            var contactpersonsInfo = "";
                            if (
                                typeof data.contactpersons !=
                                    "undefined" &&
                                data.contactpersons.length > 0
                            ) {
                                contactpersonsInfo = "<table>" +
                                                        "<tr>"+
                                                            "<td collspan='2'>Contactpersonen:</td>"+
                                                        "</tr>";
                                data.contactpersons.forEach(function(
                                    item
                                ) {
                                    contactpersonsInfo = contactpersonsInfo +
                                    "<tr>"+
                                        "<td width='150px'>"+item.name+"</td><td>"+item.phonenumber+"</td>"+
                                    "</tr>";

                                    if (item.phonenumber2 != null) {
                                    contactpersonsInfo = contactpersonsInfo +
                                        "<tr>"+
                                            "<td width='150px'>&nbsp;-&nbsp;Telefoon 2</td><td>"+item.phonenumber2+"</td>"+
                                        "</tr>";
                                    }

                                    if (item.phonenumber3 != null) {
                                    contactpersonsInfo = contactpersonsInfo +
                                        "<tr>"+
                                            "<td width='150px'>&nbsp;-&nbsp;Telefoon 3</td><td>"+item.phonenumber3+"</td>"+
                                        "</tr>";
                                    }
                                });
                                contactpersonsInfo.concat("</table>");
                            }
            return $(
                '<div class="dx-scheduler-appointment-tooltip dx-scheduler-appointment-tooltip-content">' +
                    '<div class="dx-scheduler-appointment-tooltip-title"><a href="/project/edit/' +
                    data.ProjectId + '?planning=1' +
                    '">' +
                    mcnProjectNr + " " + data.text +
                    "</a></div>" +
                    '<div class="dx-scheduler-appointment-tooltip-date">' +
                    startDate +
                    " - " +
                    endDate +
                    "</div>" +
                    '<div class="dx-scheduler-appointment-tooltip-address">' +
                    address +
                    "<br />" +
                    postcode + " " + city +
                    "</div>" +
                    '<div class="dx-scheduler-appointment-tooltip-contact">' +
                    contactpersonsInfo +
                    "</div>" +
                    '<div class="dx-scheduler-appointment-tooltip-buttons">' +
                    '<div class="delete-appointment"></div>' +
                    '<div class="edit-appointment"></div>' +
                    "</div>" +
                    "</div>"
            );
        }

        function getFirstDayOfWeek(d) {
            //week start = monday
            d = new Date(d);
            d.setHours(0, 0, 0, 0);
            var day = d.getDay(),
                diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
            return new Date(d.setDate(diff));
        }

        function getLastDayOfWeek(d) {
            d = new Date(d);
            d.setHours(23, 59, 0, 0);
            var day = d.getDay(),
                diff = d.getDate() - day + (day == 0 ? -7 : 0) + 7; // adjust when day is sunday
            return new Date(d.setDate(diff));
        }

        function getWeekNumber(d) {
            if (d == "Invalid Date") {
                d = new Date();
            }
            // Copy date so don't modify original
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
            // Set to nearest Thursday: current date + 4 - current day number
            // Make Sunday's day number 7
            d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));

            // Get first day of year
            var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));

            // Get week number
            var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

            // Get current week days
            var week = getAllDaysFromCurrentWeek(d);

            // Get first week day
            var startWeekDay = new Date(week[0]);
            var monthStart = startWeekDay.toLocaleString("nl-nl", { month: "short" });
            monthStart = monthStart.charAt(0).toUpperCase() + monthStart.slice(1);
            startWeekDay = startWeekDay.getDate();

            // Get last week day
            var endWeekDay = new Date(week[6]);
            endWeekDay = endWeekDay.getDate();

            // Get current month
            var month = d.toLocaleString("nl-nl", { month: "short" });
            month = month.charAt(0).toUpperCase() + month.slice(1);

            // Get current year
            var year = yearStart.getFullYear();

            // Return string with startday, endday, month, year and week number
            return (
                startWeekDay +
                " " +
                monthStart +
                "-" +
                endWeekDay +
                " " +
                month +
                " " +
                year +
                " (w" +
                weekNo +
                ")"
            );
        }

        function canEdit () {
            if (canEditValue === true) {
                return true
            }
            return false;
        }

        // Return all days of an week from date
        function getAllDaysFromCurrentWeek(d) {
            let curr = d;
            let week = [];

            for (let i = 1; i <= 7; i++) {
                let first = curr.getDate() - curr.getDay() + i;
                let day = new Date(curr.setDate(first))
                    .toISOString()
                    .slice(0, 10);
                week.push(day);
            }

            return week;
        }

        function getToday() {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();

            if (dd < 10) {
                dd = "0" + dd;
            }

            if (mm < 10) {
                mm = "0" + mm;
            }

            today = yyyy + "-" + mm + "-" + dd;

            return today;
        }

        window.addSortable = function() {
            $(".dx-scheduler-group-table").sortable({
                stop: function(event, ui) {
                    var previousEmployeeId = $(ui.item)
                        .prev("tr")
                        .find(".data")
                        .data("employee-id");
                    var draggedEmployeeId = $(ui.item)
                        .find(".data")
                        .data("employee-id");
                    var url = "/planner/updateemployeeorder";
                    $.ajax(url, {
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content"
                            )
                        },
                        type: "POST",
                        data: {
                            draggedEmployeeId: draggedEmployeeId,
                            previousEmployeeId: previousEmployeeId
                        },
                        success: function(result) {
                            $("#scheduler")
                                .dxScheduler("instance")
                                .repaint();
                        },
                        error: function(result) {
                            console.error(
                                "the ajax call failed, check the call"
                            );
                        }
                    });
                }
            });
        };


    }
}



// WEBPACK FOOTER //
// ./resources/js/components/planner.js